import EmblaCarousel from 'embla-carousel';
import { createLightbox } from './lightbox.js';

export default () => ({
    selectedIndex: 0,
    count: 0,
    mainApi: null,
    thumbsApi: null,
    lightbox: null,

    init() {
        const main = this.$refs.main;
        const thumbs = this.$refs.thumbs;
        if (!main) return;

        this.mainApi = EmblaCarousel(main, { loop: true });
        if (thumbs) {
            this.thumbsApi = EmblaCarousel(thumbs, { containScroll: 'keepSnaps', dragFree: true });
        }

        this.count = this.mainApi.slideNodes().length;
        const sync = () => {
            this.selectedIndex = this.mainApi.selectedScrollSnap();
            this.thumbsApi?.scrollTo(this.selectedIndex);
        };
        this.mainApi.on('select', sync).on('reInit', sync);
        sync();
    },

    destroy() {
        this.mainApi?.destroy();
        this.thumbsApi?.destroy();
        this.lightbox?.then((lightbox) => lightbox.destroy());
    },

    async open(index) {
        // Promise cached so a second click while PhotoSwipe loads doesn't build another.
        this.lightbox ??= createLightbox(this.$refs.main.querySelectorAll('a[data-pswp-width]'), {
            // Keep the carousel on the image being viewed, so closing zooms back to the right slide.
            onChange: (index) => this.mainApi?.scrollTo(index, true),
        });
        (await this.lightbox).loadAndOpen(index);
    },

    prev() {
        this.mainApi?.scrollPrev();
    },

    next() {
        this.mainApi?.scrollNext();
    },

    goTo(index) {
        this.mainApi?.scrollTo(index);
    },
});
